import { useEffect, useState } from "react";

// STYLES
import * as Style from "./FiltersComponentStyle";

// LIBRARIES
import { FiltersComponentOptions } from "config/FiltersComponentOptions";
import Dayjs from "dayjs";
import { useTranslation } from "react-i18next";

// MISC
import { InputAtomTypes } from "components/Atoms/InputAtom/InputAtomModel";
import { FiltersConfigData } from "config/FiltersConfigData";
import { ReportTypes, Tabs } from "models/GeneralTypes/generalTypes";
import {
  IFilters, LockersOption
} from "models/interfaces";

// ASSETS

// REDUX
import { getAllLockers } from "api/lockerApi";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { filters, handleEndDateChange, handleLockerSelectValueChange, handleResetFiltersState, handleSearchBarValueChange, handleStartDateChange, handleStatusTypeValueChange } from "slices/filtersSlice";
import { selectedTab } from "slices/uiSlice";

// COMPONENTS
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import SelectAtom from "components/Atoms/SelectAtom/SelectAtom";
import DatePicker from "components/DatePicker/DatePicker";

const FiltersComponent = (props) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const activeTab = useAppSelector<string>(selectedTab);
  const date = Dayjs();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const filtersData = useAppSelector<IFilters>(filters);

  // CONSTANTS USING HOOKS
  const [datePickerIsVisible, setDatePickerIsVisible] = useState<boolean>(false);
  const [lockersOptions, setLockersOptions] = useState<LockersOption[]>();
  const [reportType, setReportType] = useState<string>("")

  // GENERAL CONSTANTS
  const {
    rentalsTypeReportOptions,
    usersStatusOptions,
  } = FiltersComponentOptions();


  const { filtersPerPage } = FiltersConfigData();
  const currentConfig = filtersPerPage[activeTab]
  // USE EFFECT FUNCTION

  useEffect(() => {
    if (reportType === ReportTypes.DAILY) {
      dispatch(
        handleStartDateChange(
          date.startOf("day").toDate()
        )
      );
      dispatch(
        handleEndDateChange(
          date.endOf("day").toDate()
        )
      );
    } else if (reportType === ReportTypes.WEEKLY) {
      dispatch(
        handleStartDateChange(
          date.startOf("week").toDate()
        )
      );
      dispatch(
        handleEndDateChange(
          date.endOf("week").toDate()
        )
      );
    } else if (reportType === ReportTypes.MONTHLY) {
      dispatch(
        handleStartDateChange(
          date.startOf("month").toDate()
        )
      );
      dispatch(
        handleEndDateChange(
          date.endOf("month").toDate()
        )
      );
    } else if (reportType === ReportTypes.YEARLY) {
      dispatch(
        handleStartDateChange(
          date.startOf("year").toDate()
        )
      );
      dispatch(
        handleEndDateChange(
          date.endOf("year").toDate()
        )
      );
    }
    //eslint-disable-next-line
  }, [reportType]);

  useEffect(() => {
    if (typeof currentConfig.apiCallMethod === 'function') {
      currentConfig.apiCallMethod();
    }
    console.log("filtersData", filtersData)
    console.log("filtersData")
    // currentConfig.apiCallMethod();
  }, [filtersData])

  useEffect(() => {
    console.log("startDate", filtersData.startDate)
    console.log("endDate", filtersData.endDate)
    // currentConfig.apiCallMethod();
  }, [filtersData.startDate, filtersData.endDate])

  useEffect(() => {
    handleClearFilters()
    // eslint-disable-next-line
  }, [activeTab]);


  useEffect(() => {
    if (activeTab === Tabs.RENTALS || Tabs.RENTALS_LOGS) {
      dispatch(getAllLockers())
        .unwrap()
        .then((response) => {
          let lockersList = response.map((locker) => {
            let lockerOption = {
              key: locker.id,
              value: locker.name,
            };

            return lockerOption;
          });

          setLockersOptions(lockersList);
        });
    }
    //eslint-disable-next-line
  }, [activeTab]);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClearFilters = () => {
    dispatch(handleResetFiltersState());
    setReportType("");
  }

  return (
    <Style.FiltersComponentContainer>
      <Style.FiltersWrapper>
        {
          currentConfig?.searchBar &&
          <InputAtom
            name={t("filtersComponent.searchingInput.label")}
            inputValue={filtersData?.searchBarValue}
            setInputValue={(value) =>
              dispatch(handleSearchBarValueChange(value))}
            type={InputAtomTypes.SEARCH}
            placeholder={t("filtersComponent.searchingInput.placeholder")}
          />
        }
        {
          currentConfig?.lockerSelect &&
          <SelectAtom
            selectedOptions={filtersData?.lockerSelectValue}
            setSelectedOptions={(value) =>
              dispatch(handleLockerSelectValueChange(value))
            }
            options={lockersOptions}
            label={t("filtersComponent.selectLocker.label")}
          />
        }
        {
          currentConfig?.reportType &&
          <SelectAtom
            selectedOptions={reportType}
            setSelectedOptions={(value) =>
              setReportType(value)
            }
            options={rentalsTypeReportOptions}
            label={t("filtersComponent.reportType.label")}
          />
        }
        {
          currentConfig?.statusType &&
          <SelectAtom
            selectedOptions={filtersData?.statusTypeValue}
            setSelectedOptions={(value) =>
              dispatch(handleStatusTypeValueChange(value))
            }
            options={usersStatusOptions}
            label={t("filtersComponent.userStatus.label")}
          />
        }
        {
          currentConfig?.dateRange &&
          <DatePicker
            isVisible={datePickerIsVisible}
            startDate={filtersData?.startDate}
            handleChangeStartDate={(value) =>
              dispatch(handleStartDateChange(value))}
            endDate={filtersData?.endDate}
            handleChangeEndDate={(value) =>
              dispatch(handleEndDateChange(value))}
            handleVisibilityChange={setDatePickerIsVisible}
            isSingleDatePicker={false}
          />
        }
      </Style.FiltersWrapper>
      <Style.RightContentContainer>
        <Style.FiltersIcon onClick={handleClearFilters} fontSize="large" />
      </Style.RightContentContainer>
    </Style.FiltersComponentContainer>
  );
};

export default FiltersComponent;
